import { Auth } from 'aws-amplify'
import { jwtDecode } from 'jwt-decode'

import { getStorage, setStorage, removeStorage } from '../../api/'

const KEY = 'user'
const SKEW = 120
let pending = null

const getApiToken = u => u?.idToken || u?.token || null

export const refreshToken = async () => {
  const current = getStorage(KEY)
  const token = getApiToken(current)
  if (!token) return null

  let exp
  const now = Math.floor(Date.now() / 1000)
  try {
    exp = jwtDecode(token).exp
  } catch {
    removeStorage(KEY)
    return null
  }

  if (exp - now > SKEW) return null
  if (pending) return pending

  pending = (async () => {
    try {
      const session = await Auth.currentSession()
      const idToken = session.getIdToken().getJwtToken()
      const accessToken = session.getAccessToken().getJwtToken()

      setStorage(KEY, {
        ...current,
        token: idToken,
        idToken,
        accessToken,
        tokenType: 'id',
      })
      return idToken
    } catch (err) {
      const isAuth = /NotAuthorized|Unauthorized|expired/i.test(
        `${err?.name}:${err?.message}`
      )
      if (isAuth) removeStorage(KEY)
      return null
    } finally {
      pending = null
    }
  })()

  return pending
}
